"use strict";
(function () {

  const cssColors = {
    header: "#2D3A4D",
    text: "#333333",
    text_light: "#C1C4CA",
    text_warning: "#FFAAAA",
    background_light: "#FFFFFF",
    background_dark: "#E9ECEF",
    border_grey: "#EFF2F7",
    subheader_grey: "#D3D9E0",
    divider: "#D2D2D2",
    highlight: "#27B02B",
    disabled: "#A0A0A0",
    frame: "#CCCCCC",
    toolbar: "#EFF2F7",
    toolbar_hover: "#DAE0E9",
    catalog_light: "#F6F8FA",
    catalog_dark: "#DAE0E9",
    success_color: "#1AC876",
    danger_color: "#D9534F",
    vention_blue: "#1C344F",
    vention_blue_clicked: "#1E2631",
    greyscale_0: "#FBFBFB",
    green: "#1AC876",
    green_clicked: "#189C5F",
    green_hover: "#17B169",
    white: "#FFFFFF",
    orange:'#FF8000',
    yellow_secondary: '#F4B73A',
    link_secondary: '#667A99',
    light_grey: '#F2F2F2',
    light_green: '#1ADC76',
    black: "#000000",
  };


  function defineCssRule(pName, pRule) {
    // Note: from http://stackoverflow.com/questions/1720320/how-to-dynamically-create-css-class-in-javascript-and-apply
    let lS = document.getElementById('assembler_style');
    if(undefined == lS) {
      lS = document.createElement('style');
      lS.type = 'text/css';
      lS.id = 'assembler_style';
      document.head.appendChild(lS);
    }
    /* eslint no-debugger: 0 */

    if ('string' == typeof pRule) {
      lS.sheet.insertRule(pName + " {" + pRule + "}", 0);
    } else {
      // just to give the ability to do _define('.test', { border: '1px red solid', border-radius: '1px' })
      pRule && lS.sheet.insertRule(pName + ' ' + JSON.stringify(pRule).replace(/",/ig, ';').replace(/"/ig, ''), 0);
    }
  }

  function defineBrowserSpecificCssRule(pName, pRule) {
    try {
      defineCssRule(pName, pRule);  // Throws DOMException when defining a rule for the wrong browser
    } catch (pError) {
      // Filter out false positives
      if(!(pError instanceof DOMException) || pError.name != 'SyntaxError') {
        console.error(pError);
      }
    }
  }

  /* Module export glue */
  /* global define */
  const gExports = {
    cssColors: cssColors,
    defineCssRule: defineCssRule,
    defineBrowserSpecificCssRule: defineBrowserSpecificCssRule
  };

  const gModule = typeof module;
  if (gModule !== 'undefined' && module.exports != undefined) {
    module.exports = gExports;
  } else if (define != undefined && typeof define === 'function' && define.amd) {
    define([], function () { return gExports; });
  }
}());
